import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { WhyBuy } from './components/WhyBuy';
import { InventoryGrid } from './components/InventoryGrid';
import { MaintenanceExplainer } from './components/MaintenanceExplainer';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  useEffect(() => {
    document.title = 'Pre-Owned Boats for Sale on Lake George';
  }, []);
  return <div className="min-h-screen flex flex-col font-sans text-navy bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <WhyBuy data-id="element-4" />
        <InventoryGrid data-id="element-5" />
        <MaintenanceExplainer data-id="element-6" />
        <Testimonials data-id="element-7" />
        <FAQ data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}